import api from './api';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.hconnect.io/ui-v2';

const vaultsourcegroupService = {
  // Get all vault source groups with optional filters
  getAllVaultSourceGroups: async (filters = {}) => {
    const params = new URLSearchParams();

    if (filters.vaultsourceid) {
      params.append('vaultsourceid', filters.vaultsourceid);
    }

    if (filters.name) {
      params.append('name', filters.name);
    }

    const queryString = params.toString();
    const url = queryString ? `/vaultsourcegroup?${queryString}` : '/vaultsourcegroup';

    const response = await api.get(url);
    return response.data;
  },

  // Get a single vault source group by ID
  getVaultSourceGroupById: async (id) => {
    const response = await api.get(`/vaultsourcegroup/${id}`);
    return response.data;
  },

  // Create a new vault source group
  createVaultSourceGroup: async (vaultsourcegroupData) => {
    const response = await api.post('/vaultsourcegroup', vaultsourcegroupData);
    return response.data;
  },

  // Update an existing vault source group
  updateVaultSourceGroup: async (id, vaultsourcegroupData) => {
    const response = await api.put(`/vaultsourcegroup/${id}`, vaultsourcegroupData);
    return response.data;
  },

  // Delete a vault source group
  deleteVaultSourceGroup: async (id) => {
    const response = await api.delete(`/vaultsourcegroup/${id}`);
    return response.data;
  },

  // Get vault group selections for a vault
  getVaultGroupSelections: async (vaultId) => {
    const response = await api.get(`/vaultsourcegroup/selections?vault_id=${vaultId}`);
    return response.data;
  },

  // Save vault group selections for a vault
  setVaultGroupSelections: async (vaultId, groupIds) => {
    const response = await api.post('/vaultsourcegroup/selections', { vault_id: vaultId, group_ids: groupIds });
    return response.data;
  }
};

export default vaultsourcegroupService;
